import React, { lazy, Suspense } from "react";
import { createRoot } from 'react-dom/client';
import { AuthProvider } from "./context/AuthContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BetProvider } from "./context/BetContext";
import { CategoryProvider } from "./context/CategoryContext";
const LazyApp = lazy(() => import("./App"));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <CategoryProvider>
    <BetProvider>
      <AuthProvider>
        <Suspense fallback={<h4>Loading</h4>}>
          <LazyApp />
        </Suspense>
        <ToastContainer />
      </AuthProvider>
    </BetProvider>
  </CategoryProvider>
);
